import { MutationTree } from 'vuex';
import { ECreateTemplateMutation } from '@/content-library/create-resource/template/store/create-template.constants';
import { ICreateTemplateState } from '@/content-library/create-resource/template/store/create-template.types';

export const mutations: MutationTree<ICreateTemplateState> = {
  [ECreateTemplateMutation.SetTemplateId](state: ICreateTemplateState, templateId: string) {
    state.createdTemplateId = templateId;
  },
  [ECreateTemplateMutation.SetState](state: ICreateTemplateState, newState: ICreateTemplateState) {
    state.createdTemplateId = newState.createdTemplateId;
  },
};
